import { Icon } from './Icon.jsx';

const TONES = {
  neutral: { soft: 'var(--surface-sunken)', softFg: 'var(--text-body)',    solid: 'var(--stone-600)',  solidFg: '#fff' },
  primary: { soft: 'var(--primary-soft)',   softFg: 'var(--dala-red-deep)', solid: 'var(--primary)',    solidFg: 'var(--on-primary)' },
  info:    { soft: 'var(--info-soft)',      softFg: 'var(--viking-blue-deep)', solid: 'var(--info)',    solidFg: '#fff' },
  success: { soft: 'var(--success-soft)',   softFg: 'var(--folk-green-deep)', solid: 'var(--success)',  solidFg: '#fff' },
  warning: { soft: 'var(--warning-soft)',   softFg: 'var(--swed-gold-deep)', solid: 'var(--accent)',    solidFg: 'var(--on-accent)' },
  danger:  { soft: 'var(--danger-soft)',    softFg: 'var(--dala-red-deep)', solid: 'var(--danger)',     solidFg: '#fff' },
};

/** Badge — small status pill. Use for game states (Open / Accepted / Paid), counts, labels. */
export function Badge({ children, tone = 'neutral', variant = 'soft', dot = false, icon, style, ...rest }) {
  const t = TONES[tone] || TONES.neutral;
  const solid = variant === 'solid';
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      background: solid ? t.solid : t.soft,
      color: solid ? t.solidFg : t.softFg,
      fontFamily: 'var(--font-sans)', fontWeight: 'var(--fw-bold)',
      fontSize: 'var(--text-xs)', letterSpacing: 'var(--ls-caps)', textTransform: 'uppercase',
      padding: '4px 10px', borderRadius: 'var(--radius-pill)', lineHeight: 1.2,
      ...style,
    }} {...rest}>
      {dot && <span style={{ width: 7, height: 7, borderRadius: '50%', background: solid ? t.solidFg : t.solid }} />}
      {icon && <Icon name={icon} size={13} strokeWidth={2.5} />}
      {children}
    </span>
  );
}
